import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/font-awesome.min.css';
import './assets/css/google-roboto-300-700.css';
import './assets/css/material-dashboard.min.css';
import "filepond/dist/filepond.min.css";
import './assets/css/demo.css';
import '@yaireo/tagify/dist/tagify.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Route } from 'react-router-dom';
import { composeWithDevTools } from "redux-devtools-extension";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import setAuthorizationHeader from './utils/setAuthorizationHeader';
import { userLoggedIn, refreshToken } from './actions/auth';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';


const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
);

if (localStorage.auth) {
    const auth = JSON.parse(localStorage.auth);
    setAuthorizationHeader(auth.token);
    store.dispatch(userLoggedIn(auth));
    store.dispatch(refreshToken(auth.token));
    setInterval(() => store.dispatch(refreshToken(auth.token)), 600 * 1000);
}

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <Route component={App} />
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
